import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "psychologistName", "psychologistEmail", "clientsContainer"]

  connect() {
    this.clients = []
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget
    const psychologistName = button.dataset.psychologistName
    const psychologistEmail = button.dataset.psychologistEmail
    this.clients = JSON.parse(button.dataset.clients || '[]')

    this.psychologistNameTarget.textContent = psychologistName
    this.psychologistEmailTarget.textContent = psychologistEmail

    this.renderClients()

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  renderClients() {
    const container = this.clientsContainerTarget
    container.innerHTML = ''

    if (this.clients.length === 0) {
      container.innerHTML = `
        <div class="text-center py-8">
          <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <p class="text-sm text-gray-500">No clients assigned to this psychologist</p>
        </div>
      `
      return
    }

    this.clients.forEach(client => {
      const div = document.createElement('div')
      div.className = 'flex items-center justify-between p-3 bg-gray-50 rounded-lg'
      div.innerHTML = this.clientHTML(client)
      container.appendChild(div)
    })
  }

  clientHTML(client) {
    const statusClasses = {
      'pending': 'bg-yellow-100 text-yellow-800',
      'accepted': 'bg-green-100 text-green-800',
      'declined': 'bg-red-100 text-red-800',
      'expired': 'bg-gray-100 text-gray-800'
    }

    const statusClass = statusClasses[client.status] || 'bg-gray-100 text-gray-800'

    let topicsHTML = ''
    if (client.topics && client.topics.length > 0) {
      const displayTopics = client.topics.slice(0, 2)
      const remainingCount = client.topics.length - 2

      topicsHTML = '<div class="flex flex-wrap gap-1 mt-1">'
      displayTopics.forEach(topic => {
        topicsHTML += `<span class="px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded text-xs">${this.escapeHtml(topic)}</span>`
      })
      if (remainingCount > 0) {
        topicsHTML += `<span class="px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded text-xs">+${remainingCount}</span>`
      }
      topicsHTML += '</div>'
    }

    return `
      <div>
        <p class="text-sm font-medium text-gray-900">${this.escapeHtml(client.email)}</p>
        <div class="flex items-center gap-2 mt-0.5">
          <span class="px-2 py-0.5 text-xs font-medium rounded-full ${statusClass}">
            ${this.escapeHtml(this.titleize(client.status))}
          </span>
          <span class="text-xs text-gray-400">${this.escapeHtml(client.sent_at)}</span>
        </div>
        ${topicsHTML}
      </div>
    `
  }

  titleize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text || ''
    return div.innerHTML
  }
}
